// removed by extract-text-webpack-plugin
module.exports = {"articleFooter":"articleFooter--2MwGd","separator":"separator--1328J"};